import { render, staticRenderFns } from "./rule-add-or-update.vue?vue&type=template&id=1d250bb0&"
import script from "./rule-add-or-update.vue?vue&type=script&lang=js&"
export * from "./rule-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports